"use client";

import { Area, AreaChart, CartesianGrid, Label, XAxis, YAxis } from "recharts";

import { CardContent } from "../../../../third-party/shadcn/card";
import {
  ChartConfig,
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from "../../../../third-party/shadcn/chart";
import { IntegrationItem } from "../../../../models/integration-item.model";
import { useEffect, useState } from "react";

interface Props {
  data: IntegrationItem[];
}

const chartConfig = {} satisfies ChartConfig;

export const TotalDurationAreaChart: React.FC<Props> = (props: Props) => {
  const { data } = props;

  const [chartProps, setChartProps] = useState<
    { duration: number; recentAttempt: number; key: string }[]
  >([]);

  const init = () => {
    const totalDurationAreaChartData = data.map((item, index) => ({
      duration: item.duration,
      recentAttempt: index + 1,
      key: item.id,
    }));
    setChartProps(totalDurationAreaChartData);
  };
  useEffect(() => {
    init();
  }, [data]);
  return !chartProps ? (
    <>Loading...</>
  ) : (
    <>
      <CardContent className="h-full w-full p-0 pb-0">
        <ChartContainer
          config={chartConfig}
          className="!aspect-auto h-full w-full min-h-[220px]"
        >
          <AreaChart
            accessibilityLayer
            data={chartProps}
            margin={{ top: 8, right: 12, left: 4, bottom: 8 }}
          >
            <CartesianGrid vertical={false} horizontal={false} />
            <XAxis
              dataKey="recentAttempt"
              tickLine={false}
              axisLine={false}
              tickMargin={4}
              height={40}
            >
              <Label
                value="Recent run attempts"
                position="insideBottom"
                offset={-4}
                style={{ textAnchor: "middle", fill: "#5C6578" }}
              />
            </XAxis>
            <YAxis
              dataKey="duration"
              tickLine={false}
              axisLine={false}
              width={50}
              tickCount={5}
            >
              <Label
                value="Duration (Seconds)"
                angle={-90}
                position="insideLeft"
                style={{ textAnchor: "middle", fill: "#5C6578" }}
              />
            </YAxis>
            <ChartTooltip
              cursor={false}
              content={<ChartTooltipContent indicator="line" />}
            />
            <Area
              dataKey="duration"
              type="natural"
              fill="#5EB8D4"
              fillOpacity={0.25}
              stroke="#5EB8D4"
              strokeWidth={1.5}
            />
          </AreaChart>
        </ChartContainer>
      </CardContent>
    </>
  );
};
